import { useTheme } from '@shopify/restyle';
import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';
import { Thumbnail } from 'app/design/primitives/thumbnail';
import { Grid } from 'app/design/primitives/grid';
import type { Theme } from 'app/shopify';
import type { InvitedUsers } from './shared';

export function InvitedUsersGrid({
  invitedUsers,
  isReferralProgram,
  numInvited,
  tPrefix,
}: {
  invitedUsers: InvitedUsers;
  isReferralProgram: boolean;
  numInvited: number;
  tPrefix: string;
}) {
  const theme = useTheme<Theme>();
  const maxInvitesToDisplay = 10;
  return (
    <>
      <Grid columns={5} gap="spacing.general.x2" rowJustify="flex-start">
        {invitedUsers
          .slice(0, numInvited > maxInvitesToDisplay ? maxInvitesToDisplay - 1 : maxInvitesToDisplay)
          .map((invitedUser) => (
            <Thumbnail
              height={30}
              key={invitedUser.id}
              source={{ uri: invitedUser.profile.picture }}
              style={{ marginBottom: 0 }}
            />
          ))}
        {numInvited > maxInvitesToDisplay ? (
          <Text
            fontSize={18}
            fontWeight="700"
            lineHeight={24}
            padding="spacing.general.x0,5"
            style={{
              color: theme.colors['text.placeholder'],
              bottom: 2,
              borderColor: theme.colors['surface.brand.default'],
              borderRadius: 17.5,
              borderWidth: 3,
              height: 35,
              width: 35,
              textAlign: 'center',
            }}
          >
            +{numInvited - (maxInvitesToDisplay - 1)}
          </Text>
        ) : null}
      </Grid>
      {isReferralProgram ? (
        <Text
          fontSize={14}
          textAlign="center"
          variant="bodyBase"
          style={{
            backgroundColor: theme.colors['surface.tertiary-neutral'],
            padding: theme.spacing['spacing.general.x2'],
            borderRadius: theme.borderRadii['radius.sm'],
            marginTop: theme.spacing['spacing.general.x2'],
          }}
        >
          <Trans
            components={{ strong: <Text fontWeight="700" /> }}
            count={numInvited}
            i18nKey={`${tPrefix}referrals.rewardMessage`}
            ns="invite"
          />
        </Text>
      ) : null}
    </>
  );
}
